import { useEffect } from "react";
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorChallengeNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface IChallengeModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
  }

export const IChallengeFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges"
];

export function useChallengeHookNae(id: number) : IChallengeModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorChallengeNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: "challenge",
        fields: IChallengeFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
